module.exports = __webpack_public_path__ + "img/Background3.204dac87.png";